// This file is auto-generated by @hey-api/openapi-ts

import { client } from './Client.gen';
import type { EshopGlobalSettingControllerGetAllData } from './EshopGlobalSettingControllerGetAllData.gen';
import type { EshopGlobalSettingControllerGetAllErrors } from './EshopGlobalSettingControllerGetAllErrors.gen';
import type { EshopGlobalSettingControllerGetAllResponses } from './EshopGlobalSettingControllerGetAllResponses.gen';
import type { EshopGlobalSettingControllerGetMapPhoneGlobalSettingsData } from './EshopGlobalSettingControllerGetMapPhoneGlobalSettingsData.gen';
import type { EshopGlobalSettingControllerGetMapPhoneGlobalSettingsErrors } from './EshopGlobalSettingControllerGetMapPhoneGlobalSettingsErrors.gen';
import type { EshopGlobalSettingControllerGetMapPhoneGlobalSettingsResponses } from './EshopGlobalSettingControllerGetMapPhoneGlobalSettingsResponses.gen';
import type { Options } from './Options.gen';

export class EshopGlobalSettingController {
    /**
     * Get eshop global settings
     */
    public static getAll<ThrowOnError extends boolean = false>(options?: Options<EshopGlobalSettingControllerGetAllData, ThrowOnError>) {
        return (options?.client ?? client).get<EshopGlobalSettingControllerGetAllResponses, EshopGlobalSettingControllerGetAllErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/global-settings',
            ...options
        });
    }
    
    /**
     * Get map phone global settings
     */
    public static getMapPhoneGlobalSettings<ThrowOnError extends boolean = false>(options: Options<EshopGlobalSettingControllerGetMapPhoneGlobalSettingsData, ThrowOnError>) {
        return (options.client ?? client).get<EshopGlobalSettingControllerGetMapPhoneGlobalSettingsResponses, EshopGlobalSettingControllerGetMapPhoneGlobalSettingsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/global-settings-map-phone',
            ...options
        });
    }
}
